import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {getUser} from '../modules/selectors'

import {redirectUsersFromCallbackUrl} from '../modules/thunks'

export const CognitoPasswordlessHandler = () => {
  const dispatch = useDispatch()
  const user = useSelector(getUser)

  // Cognito authentication handler
  useEffect(() => {
    const authenticateUser = async () => {
      dispatch(redirectUsersFromCallbackUrl())
    }

    if (user) {
      void authenticateUser()
    }
  }, [user, dispatch])

  return null
}
